module.exports = __webpack_public_path__ + "media/images/help/wd-dataset-access-60fda7448d84b4cf2081e02c160f36fc.png";